import { FunctionComponent } from 'react';
import ExternalLink from './ExternalLink';
import InternalLink from './InternalLink';
import type { LinkCollectionEntry } from '../../graphql/pimcore/modules/siteContent/types/SiteContentElement';

interface LinkProps {
    link: LinkCollectionEntry;
    /** CSS classes to apply to the <a> or <Link> element. */
    className?: string;
}

const Link: FunctionComponent<LinkProps> = ({ link, className }) => {
    switch (link.kind) {
        case 'externalLinkFieldCollection':
            return (
                <ExternalLink url={link.linkUrl} className={className}>
                    {link.linkText}
                </ExternalLink>
            );

        case 'internalLinkFieldCollection':
            return (
                <InternalLink route={link.linkRoute} className={className}>
                    {link.linkText}
                </InternalLink>
            );

        default:
            return null;
    }
};

export default Link;
